import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { createNote } from '@/api/notes';

export default function CreateForm() {
  const navigate = useNavigate();
  const [title, setTitle] = useState('');
  const [content, setContent] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setError(null);

    const trimmedTitle = title.trim();
    const trimmedContent = content.trim();
    if (!trimmedTitle) {
      setError('Title is required');
      return;
    }
    if (!trimmedContent) {
      setError('Content is required');
      return;
    }

    setSubmitting(true);
    try {
      await createNote({ title: trimmedTitle, content: trimmedContent });
      navigate('/backend', { state: { noteCreated: true } });
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Failed to create note');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="mt-6 max-w-xl space-y-4">
      {error && (
        <div
          className="rounded-md bg-red-900/30 border border-red-700 text-red-300 px-4 py-2 text-sm"
          role="alert"
        >
          {error}
        </div>
      )}
      <div>
        <label htmlFor="note-title" className="block text-sm font-medium text-gray-300 mb-1">
          Title <span className="text-red-400">*</span>
        </label>
        <input
          id="note-title"
          type="text"
          value={title}
          onChange={(e) => setTitle(e.target.value)}
          required
          className="w-full rounded-md border border-gray-600 bg-gray-800 px-3 py-2 text-white placeholder-gray-500 focus:border-indigo-500 focus:outline-none focus:ring-1 focus:ring-indigo-500"
          placeholder="Note title"
          disabled={submitting}
        />
      </div>
      <div>
        <label htmlFor="note-content" className="block text-sm font-medium text-gray-300 mb-1">
          Content <span className="text-red-400">*</span>
        </label>
        <textarea
          id="note-content"
          value={content}
          onChange={(e) => setContent(e.target.value)}
          rows={4}
          className="w-full rounded-md border border-gray-600 bg-gray-800 px-3 py-2 text-white placeholder-gray-500 focus:border-indigo-500 focus:outline-none focus:ring-1 focus:ring-indigo-500 resize-y"
          placeholder="Note content"
          disabled={submitting}
        />
      </div>
      <button
        type="submit"
        disabled={submitting}
        className="inline-flex items-center justify-center rounded-md font-medium bg-indigo-600 hover:bg-indigo-700 text-white shadow-sm px-4 py-2 transition-colors focus:outline-none disabled:opacity-50 disabled:pointer-events-none"
      >
        {submitting ? 'Creating…' : 'Create Note'}
      </button>
    </form>
  );
}
